import "src/javascripts/vendor/typeahead.jquery";
import "src/javascripts/vendor/bloodhound";
import Spinner from "src/javascripts/components/utilities/Spinner";
import UpdateConditionals from "src/javascripts/components/surveys/functions/UpdateConditionals";
import {
  createCategoryTag,
  removeCategoryTag,
  updateTempInput,
  toggleCategoriesContainer,
  getCurrentCategories,
  clearAllCategories
} from "src/javascripts/components/helpers/CategoryTagHelper";

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require("src/javascripts/vendor/bloodhound");

export default class ManualListTypeahead {
  constructor(el) {
    this.el = el;
  }

  render(id) {
    if (typeof id === "undefined") {
      return;
    }

    // Toggle new data indicator
    let toggleNewData = function (el) {
      let cardBody = el.closest(".survey-card-body");
      let userId = cardBody.attr("data-user-id");
      const len = (el.val() || '').length;
      if (len > 0) {
        cardBody.attr("data-val-changed", "true");
        cardBody.find(".user-id").attr("value", userId);
        cardBody.find(".new-data").attr("value", true);
      } else {
        cardBody.attr("data-val-changed", "false");
        cardBody.find(".user-id").attr("value", "");
        cardBody.find(".new-data").attr("value", false);
      }
    };

    let listOptions = [];
    let i = 0;
    let dataOpts = JSON.parse($("#" + id).attr("data-list-options"));
    while (i < dataOpts.length) {
      listOptions.push(dataOpts[i]);
      i++;
    }

    var substringMatcher = function (strs) {
      return function findMatches(q, cb) {
        // an array that will be populated with substring matches
        let matches = [];

        // regex used to determine if a string contains the substring `q`
        let substrRegex = new RegExp(q, "i");

        // iterate through the pool of strings and for any string that
        // contains the substring `q`, add it to the `matches` array
        $.each(strs, function (i, str) {
          if (substrRegex.test(str)) {
            matches.push(str);
          }
        });

        cb(matches);
      };
    };

    $("#" + id).typeahead(
      {
        hint: true,
        highlight: false,
        minLength: 0,
      },
      {
        name: "list",
        limit: 554,
        source: substringMatcher(listOptions),
        cache: false,
      },
    );

    // Handle typeahead menu clicks to prevent dropdown closing
    $("#" + id).on("typeahead:opened", function () {
      $(".tt-menu")
        .off("click.preventClose")
        .on("click.preventClose", function (e) {
          e.stopPropagation();
        });
    });

    $("#" + id).bind("typeahead:beforeselect", function (ev, suggestion) {
      try {
        // Only call toggleNewData if we're in a survey context
        let cardBody = $(this).closest(".survey-card-body");
        if (cardBody.length > 0) {
          toggleNewData($(this));
        }

        // Define action to take
        let action = $("#" + id).attr("data-action");

        if (action === "visit_page") {
          let requestUrl = $("#" + id).attr("data-request-url");
          let key = $("#" + id).attr("data-key");
          let params = JSON.parse($("#" + id).attr("data-params"));
          params[key] = suggestion.value;
          Turbo.visit(requestUrl + "?" + $.param(params));
        } else if (action === "fill_hidden_field") {
          let dataKey = $("#" + id).attr("data-key");
          let selector = $("#" + id).attr("data-selector");
          let value;
          if (typeof dataKey !== "undefined") {
            value = suggestion[dataKey];
            $(selector).val(value);
          } else {
            value = suggestion;
            $(selector).val(value);
          }
        } else if (action === "add_category_to_selection") {
          // Prevent dropdown from closing
          ev.preventDefault();
          ev.stopPropagation();

          // Handle adding category to temporary selection (don't apply filter yet)
          let tempInput = $("#temp_categories_input");
          let tempContainer = $(".temp-categories-container");
          let selectedCategoriesDiv = $(".selected-categories-container");

          // Check if required elements exist
          if (
            tempInput.length === 0 ||
            tempContainer.length === 0 ||
            selectedCategoriesDiv.length === 0
          ) {
            console.warn("Required elements for category selection not found");
            return false;
          }

          let currentCategories = [];
          let tempValue = tempInput.val();
          if (tempValue && tempValue.length > 0) {
            currentCategories = tempValue.includes("|")
              ? tempValue.split("|")
              : [tempValue];
          }

          // Add the new category if not already selected
          if (!currentCategories.includes(suggestion)) {
            currentCategories.push(suggestion);

            // Update the hidden input
            tempInput.val(currentCategories.join("|"));

            // Create visual tag using helper
            let categoryTag = createCategoryTag(suggestion);
            tempContainer.append(categoryTag);
            toggleCategoriesContainer(true);
          }

        }

        // Blur only for non-category actions
        $(this).blur();

      } catch (error) {
        console.error("Error in typeahead:beforeselect handler:", error);
        return false;
      }
    });

    // Initialize selected categories from URL params
    this.initializeSelectedCategories();

    // Clear
    $(".clear-manual-typeahead")
      .off()
      .on("click", function () {
        try {
          let cardBody = $(this).closest(".survey-card-body");
          let ig = $(this).closest(".input-group");
          let input = ig.find(".twitter-typeahead input");
          let el = ig.find(".manual-list-typeahead:not(.tt-hint)");
          let id = el.attr("id");
          ig.find("input[type=\'hidden\']").val("");

          // Update answer text field if in survey context
          if (cardBody.length > 0) {
            let answerTextField = ig.find('.answer-text');
            if (answerTextField.length > 0) {
              answerTextField
                .val('')
                .css('background', '')
                .removeClass('no-asc no-desc yes-asc yes-desc information-not-available filled')
                .prop('readonly', false)
                .change();

              // Clearing a value is still a change; keep new-data flags set so
              // autosave/poll services re-evaluate conditionals server-side.
              const userId = cardBody.attr('data-user-id');
              cardBody.attr('data-val-changed', 'true');
              cardBody.find('.user-id').attr('value', userId || '');
              cardBody.find('.new-data').attr('value', true);
              answerTextField.closest('.question-row').find('.new-data').attr('value', true);

              // Clear-button updates can bypass blur handlers; explicitly
              // re-evaluate dependencies so related rows/tables hide immediately.
              if (ig.attr('data-has-dependencies') === 'true') {
                UpdateConditionals(ig, '');
              }
            }
          }

          // Also clear temporary category selection
          clearAllCategories();

          $("#" + id).typeahead("destroy");
          let t = new ManualListTypeahead(el);
          t.render(id);
          if (input.length > 0) {
            input.typeahead("val", "");
            // Use setTimeout to ensure the input is properly focused after render
            setTimeout(function () {
              input.focus();
              // Trigger the input to open the typeahead dropdown
              input.trigger("focus").trigger("input");
            }, 100);
          }
        } catch (error) {
          console.error("Error in clear-manual-typeahead handler:", error);
        }
      });

    // Bind Clear All button handler
    this.bindClearAllHandler();
  }

  initializeSelectedCategories() {
    try {
      // Initialize selected categories from URL params when page loads
      let categoryParam = new URLSearchParams(window.location.search).get(
        "category",
      );
      if (categoryParam) {
        let categories = categoryParam.includes("|")
          ? categoryParam.split("|")
          : [categoryParam];
        let tempInput = $("#temp_categories_input");
        let tempContainer = $(".temp-categories-container");
        let selectedCategoriesDiv = $(".selected-categories-container");

        // Check if required elements exist
        if (
          tempInput.length === 0 ||
          tempContainer.length === 0 ||
          selectedCategoriesDiv.length === 0
        ) {
          console.warn(
            "Required elements for category initialization not found",
          );
          return;
        }

        updateTempInput(categories);

        categories.forEach((category) => {
          let categoryTag = createCategoryTag(category);
          tempContainer.append(categoryTag);
        });

        if (categories.length > 0) {
          toggleCategoriesContainer(true);
        }

        // Add event listener to prevent dropdown closing when clicking on category tags
        selectedCategoriesDiv.on("click", ".temp-category-tag", function (e) {
          e.stopPropagation();
        });

        // Bind Clear All button handler
        this.bindClearAllHandler();
      }
    } catch (error) {
      console.error("Error in initializeSelectedCategories:", error);
    }
  }

  bindClearAllHandler() {
    // Clear All Categories button handler
    $(".clear-all-categories")
      .off()
      .on("click", function (e) {
        try {
          e.preventDefault();
          e.stopPropagation();

          clearAllCategories();
        } catch (error) {
          console.error("Error in clear-all-categories handler:", error);
        }
      });
  }
}
